module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAABb0lEQVRIib3WO0tdQRDA8Z/XB5hCQREF7aOC2CUiphM/QtJYKFZ2Vpb5DqnSpTBgI9ikMIWVj8KQYCMabmMEQRBEEXwnMSzsDZfLfXk89wwcmJ2Zs//d2WVmmx7nJZUWdOAPLvFYa55cQlAPfuEMF9hFb6Ng79BfNB7FUqNgI2VsUxhsBGy4gn0ibVg3Xlfwpb6zBbRW8LWkCQvpW6ziv0oL1oVVtFWJOUoD1ok1vKwRd1jNWchxOPRQSwbwA59iZRDP5yte1bGoD8iX2O6wgY8B1oTtklWPYS7qk3FcjwzFr1Teojmksb1MembwIuo1y1CdMparcF1zNS5CErlMWkGSSD5L2F6WsIOsYOc4zgq2Ezp5VrBNz+hnT5WtrGAP+JYVLJzXbVawLwUlwH6XCfiL+6ifPgMU5v5cDLvBz5Kg0GKuo76O/YSwZZwUBqEIh5dsaCHT8fEZwCtFP4QdjmMWb9BXR/rDjr7j/X8L/gEd5zwViC21zAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nice.png
// module id = jHkg
// module chunks = 1